import { LoginTranslation } from '../../types/login.types';

export const login: LoginTranslation = {
  title: 'Welcome to the Counter Desk',
  userLabel: 'USER',
  userPlaceholder: 'Enter your username',
  passwordLabel: 'PASSWORD',
  passwordPlaceholder: 'Enter your password',
  submit: 'SIGN IN',
  forgotPassword: 'Forgot password',
  captchaRequired: 'Captcha is required!',
};

export default login;
